import { render, staticRenderFns } from "./TalentSection.vue?vue&type=template&id=7cdc5a9f&scoped=true"
import script from "./TalentSection.vue?vue&type=script&lang=js"
export * from "./TalentSection.vue?vue&type=script&lang=js"
import style0 from "./TalentSection.vue?vue&type=style&index=0&id=7cdc5a9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdc5a9f",
  null
  
)

export default component.exports